import { render, staticRenderFns } from "./PauseBase.vue?vue&type=template&id=9268a25a&scoped=true&"
import script from "./PauseBase.vue?vue&type=script&lang=ts&"
export * from "./PauseBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9268a25a",
  null
  
)

export default component.exports